import { CurationListPage } from './CurationList.page';

export const curationListRouter = {
  '/@/curations': CurationListPage,
};
